import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ConfirmEventType, ConfirmationService, MessageService } from 'primeng/api';
import { UserService } from 'src/app/core/services/user.service';
import { GlobalObservableService } from 'src/app/core/services/global-observable.service';

@Component({
  selector: 'globot-delete-account',
  templateUrl: './delete-account.component.html',
  styleUrls: ['./delete-account.component.scss'],
})
export class DeleteAccountComponent {
  constructor(
    private userService: UserService,
    private router: Router,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private globalService: GlobalObservableService
  ) {}

  deleteAccount() {
    this.confirmationService.confirm({
      message:
        '¿En serio quieres eliminar tu cuenta para siempre? No habrá manera de restaurar tu cuenta.',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.userService.deleteUser().subscribe({
          next: () => {
            this.userService.logout();
            this.confirmationService.close();
            this.globalService.publish('accountDeleted');
          },
          error: () => {
            this.messageService.add({
              severity: 'error',
              summary: 'Acción fallida',
              detail: 'La cuenta no pudo eliminarse',
            });
            this.confirmationService.close();
          },
        });
      },
      reject: (type: ConfirmEventType) => {
        switch (type) {
          case ConfirmEventType.REJECT:
          case ConfirmEventType.CANCEL:
            this.messageService.add({
              key: 'tst',
              severity: 'warn',
              summary: 'Acción cancelada',
              detail: 'Eliminar cuenta cancelado',
            });
            break;
        }
        this.confirmationService.close();
      },
    });
  }
}
